<template>
  <div>
    <lunbo></lunbo>
    <div class="notice-page">
      <div class="notice-main">
        <div class="notice-title">
          <h1>{{itemData.title}}</h1>
        </div>
        <div class="notice-meta">
          <span>时间：{{itemData.updateTime}}</span>
          <span>字体：[大 中 小]</span>
        </div>
        <div class="notice-content" v-html="content"></div>
      </div>

      <div class="notice-sidebar">
        <div class="sidebar-block">
          <h3 v-if="typeCode == 1">中物鉴智动态</h3>
          <h3 v-if="typeCode == 2">报奖通知</h3>
          <h3 v-if="typeCode == 3">获奖公告</h3>
          <div class="dir"></div>
          <ul>
            <li
              v-for="item in listData"
              :key="item.notifyId"
              @click="deilsData(item)"
              :class="{ active: item.notifyId == id }"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import lunbo from '@/components/lunbo.vue';
import Footer from '@/components/Footer.vue';
import { publishedPage, notifyIdDetail } from '@/api/account';

export default {
  name: 'NoticeDetail',
  components: {
    lunbo,
    Footer
  },
  data() {
    return {
      id: '',
      content: '',
      listData: [],
      typeCode: '',
      itemData:{},
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getDeils();
  },
  methods: {
    getList(typeCode) {
      publishedPage({
        typeCode: typeCode,
        pageSize: 5,
        pageNumber: 1
      }).then((res) => {
        if (res.code == 200) {
          this.listData = res.data?.pageRecords || [];
        }
      });
    },
    deilsData(item) {
      this.id = item.notifyId;
      this.$router.replace({ query: { id: item.notifyId } });
      notifyIdDetail(item.notifyId).then((res) => {
        if (res.code == 200) {
          this.content = res.data.content;
          this.typeCode = res.data.typeCode;
          this.itemData = res.data;
          this.getList(res.data.typeCode);
        }
      });
    },
    getDeils() {
      notifyIdDetail(this.id).then((res) => {
        if (res.code == 200) {
          this.content = res.data.content;
          this.typeCode = res.data.typeCode;
          this.itemData = res.data;
          this.getList(res.data.typeCode);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.notice-page {
  max-width: 1300px;
  margin: 0 auto;
  padding: 30px 20px;
  display: flex;
  gap: 30px;
  font-family: "Microsoft YaHei", sans-serif;
  background: #fff;
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px 15px;
    gap: 20px;
  }
  margin-bottom: 20px;
}

.notice-main {
  flex: 1;
  min-width: 0;
}

.notice-title {
  text-align: center;
  margin-bottom: 20px;

  h1 {
    font-size: 22px;
    margin: 0;
    line-height: 1.5;
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
}

.notice-meta {
  display: flex;
  gap: 20px;
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  flex-wrap: wrap;
}

.notice-content {
  font-size: 15px;
  line-height: 1.8;
  color: #333;
  padding:0px 30px;
  overflow-x: auto;

  p {
    margin: 0 0 12px;
    text-align: justify;
  }

  img {
    max-width: 100% !important;
    height: auto !important;
  }

  h4 {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 20px 0 10px;
  }
  @media (max-width: 768px) {
    font-size: 14px;
  }
}

.notice-sidebar {
  width: 280px;
  flex-shrink: 0;
  @media (max-width: 768px) {
    width: 100%;
  }
}

.sidebar-block {
  margin-bottom: 30px;

  h3 {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    margin: 0 0 15px;
    padding-left: 12px;
    position: relative;
    line-height: 1.4;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 2px;
      bottom: 2px;
      width: 4px;
      background-color: #0066cc;
      border-radius: 2px;
    }
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }

  .dir {
    border-bottom: #e5e5e5 1px dashed;
    margin-bottom: 20px;
    line-height: 20px;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      position: relative;
      line-height: 36px;
      padding-left: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
      font-size: 15px;
      &:hover {
        color: #0066cc;
      }

      /* 选中高亮 */
      &.active {
        color: #0066cc;
        font-weight: 500;
      }
    }
  }
}
</style>